import classNames from 'classnames';
import AsyncButton from '../generic/forms/AsyncButton';
import Icon from '../generic/Icon';
import * as style from './FacetButton.module.css';

export interface Props {
    title: string;
    selected?: boolean;
    selectable?: boolean;
    onClick(): Promise<void> | void;
}

export default function FacetButton({ title, selected = false, selectable = false, onClick }: Props) {
    return (
        <AsyncButton
            className={classNames(style.facetButton, { [style.selected]: selected, [style.selectable]: selectable })}
            onClick={onClick as () => Promise<void>}
        >
            <span>{title}</span>
            {selected && <Icon className="icon-xmark" />}
        </AsyncButton>
    );
}
